<script setup lang="ts">
import * as da from '@/strings/da'

defineProps<{ disabled: boolean }>()
defineEmits<{ start: [] }>()
</script>

<template>
	<section class="intro">
		<ul class="points">
			<li v-for="point in da.page.introPoints" :key="point">
				<span class="bullet" aria-hidden="true">□</span>
				<span>{{ point }}</span>
			</li>
		</ul>

		<button type="button" class="btn btn-tcx btn-lg" :disabled="disabled" @click="$emit('start')">
			{{ da.page.start }}
		</button>
	</section>
</template>

<style scoped>
.intro {
	display: flex;
	flex-direction: column;
	gap: 22px;
	align-items: flex-start;
}

.points {
	margin: 0;
	padding: 0;
	list-style: none;
}

.points li {
	display: flex;
	gap: 10px;
	padding: 6px 0;
	max-width: 62ch;
	font-size: 0.9375rem;
}

.bullet {
	color: var(--tcx-teal);
	font-size: 1.125rem;
	line-height: 1.35;
}

@media (max-width: 560px) {
	.intro .btn {
		width: 100%;
	}
}
</style>
